export default "__VITE_ASSET__607da848__"